import type { KpiCardSpec } from './card-spec';

/**
 * The Avg active days per user scalar, shown on the Engagement page's Usage &
 * adoption section.
 */
export const AVG_ACTIVE_DAYS_PER_USER_SCALAR_CARD: KpiCardSpec = {
    title: 'Avg active days per user',
    source: 'login-retention',
    form: 'number',
    metric: 'averageActiveDaysPerUser',
    size: 'sm',
    description:
        'Of the people who used the full app in the selected period, the average number of distinct days each was active. It reads on its own scale, not as a percentage: 3.2 means the average active user opened the app on 3.2 separate days. Same login-retention base as Returning user rate.',
};
